import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import GetSummary from "./GetSummary";
import TempaltePrompt from "./TemplatePrompt";

const SummaryTabs = () => {
    const [activeTab, setActiveTab] = useState("tempalte"); // Default: document

    return (
        <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="gap-3 summary-tab mt-5" 
        >
            {/* <Tab eventKey="document" title="Document Type">
                <GetSummary type="document" />
            </Tab> */}
            <Tab eventKey="length" title="Length Type">
                <GetSummary type="length" />
            </Tab>
            <Tab eventKey="tempalte" title="Template">
                <TempaltePrompt type="tempalte" />
            </Tab> 
        </Tabs>
    );
};

export default SummaryTabs;
